module.exports = __webpack_public_path__ + "media/fonts/formular-medium-webfont-8f43bf27234463bc6c102912d18fe3bb.woff2";